import React, { FC, useEffect } from 'react'
import { orderMobx } from 'restaurant'
import { observer } from 'mobx-react'
import { cartMobx, payPlanMobx, restaurantCenter, shopcartMobx } from 'mobx/mall'
import { deliveryMobx, memberMobx } from '@mobxStore'
import { IonFooter } from '@ionic/react'
import { getHistoryNew, showMsg, loadingLayer, modalLayer } from '@utils'
import { ConfirmModal, SelectAddressModal } from '@cps'
import deliveryController from '@ctrls/deliveryController'
import { SettlementCard } from '@pages/mall/checkout/component'
import { payOrder } from '@common/utils/payMall'
import { SoldWarnModal } from '@pages/checkout/modal'
import './index.scss'

const CartFooter: FC = () => {
  const history = getHistoryNew()
  const { cartResult, contactLoading } = cartMobx
  const { hasAddresses } = deliveryMobx
  const isCanOrder = cartMobx.cartResult.totalCnt && cartResult.isCanSave && !contactLoading

  // 判断是否有售罄商品
  const handleDisableProductConfirm = () => {
    if (cartMobx.viewDisabledCartItems.length) {
      modalLayer(SoldWarnModal, { errData: cartMobx.viewDisabledCartItems }).then(() => {
        cartMobx.clearDisabledItems()
        handlePayAction()
      }).catch(() => {
        cartMobx.clearDisabledItems()
        history.goBack()
      })
    } else {
      handlePayAction()
    }
  }

  const handleGoBack = () => {
    history.goBack()
  }

  const handleGoMall = () => {
    history.replace('/mall')
  }

  // 支付按钮逻辑
  const handlePayAction = () => {
    modalLayer.closeAll()
    // 若支付金额不为0，唤出收银台。否则直接支付
    if (payPlanMobx.totalAmount) {
      modalLayer(SettlementCard, null, 'settlementCardModal')
        .then(() => { })
        .catch(() => { })
    } else {
      payOrder({
        history,
        handlePayAction,
        handleSaveError: () => {
          modalLayer(ConfirmModal, {
            title: i18n.t('common.attention'),
            confirmText: i18n.t('cart.refreshMenu'),
            children: (<span>{i18n.t('cart.errorProduct')}</span>),
            className: 'cart-confirm-modal'
          }, 'confirmModal').then(() => {
            loadingLayer.show()
            restaurantCenter.initAll()
            setTimeout(() => loadingLayer.hide(), 2000)
          }).catch(() => {})
        }
      })
    }
  }

  // 取消按钮
  const cancelButtonRender = () => {
    return (
      shopcartMobx.isTarget ? (
        <button className='default-btn btn' data-cypid='cartFooterClose' onClick={handleGoMall}>{i18n.t('mall.addCart')}</button>
      ) : (
        <button className='default-btn btn' data-cypid='cartFooterClose' onClick={handleGoBack}>{i18n.t('common.cancel')}</button>
      )
    )
  }

  // 支付按钮
  const payButtonRender = () => {
    return (
      <button
        className='btn primary-btn'
        data-cypid='cartFooterPay'
        onClick={() => {
          // 必须登录
          if (!memberMobx.isLogin) return history.push('/login')
          // 判断联系信息是否填写
          if (!cartMobx.isContactInfoFill()) {
            if (hasAddresses) {
              modalLayer(SelectAddressModal, { type: 'mall' }, 'SelectAddressModal').then(() => {}, () => {})
            } else {
              deliveryController.editAddressModal({
                type: 'mall',
                callback (store) {}
              })
            }
            return
          }
          // // 当前不可下单的状态
          if (!isCanOrder) {
            showMsg(i18n.t('cart.orderTips'))
            return
          }
          handleDisableProductConfirm()
        }}
      >
        {i18n.t('pay.pay')}
      </button>
    )
  }

  useEffect(() => {
    // 结算页商品清空自动退出结算页
    (!cartMobx.cartItems.length && !orderMobx.order.ordersId) && handleGoBack()
  }, [cartMobx.cartItems.length])

  return (
    <IonFooter className='mall-cart-footer'>
      <div className='cart-button-footer'>
        {cancelButtonRender()}
        {payButtonRender()}
      </div>
    </IonFooter>
  )
}

export default observer(CartFooter)
